<template>
  <section class="special-gifts-solutions">
    <v-container class="pb-0 pb-md-5">
      <h2 class="color-golden text-center">Дизайнерские решения</h2>
    </v-container>

    <div class="special-gifts-solutions__menu d-none d-md-block">
      <v-container class="d-flex justify-space-between py-0">
        <v-btn v-for="item in items"
               :key="'menuButton' + item.id"
               class="special-gifts-solutions__menu-item size1--h"
               text plain :ripple="false"
               :class="{'--active': currentSolution.trigger === item.anchor}"
               @click="onMenuItemClick(item.anchor)"
               v-html="item.menuName"></v-btn>
      </v-container>
    </div>

    <div class="overflow-hidden">
      <v-container id="solutions-container" class="pt-0">
        <div class="special-gifts-solutions__items d-flex flex-column">
          <special-gifts-solution v-for="item in items" :item="item" :key="'solution' + item.id" :current-solution="currentSolution"/>
        </div>
      </v-container>
    </div>
  </section>
</template>

<script>
import {scrollTo} from "@/utils/utils";
import SpecialGiftsSolution from "@/views/SpecialGifts/special-gifts-solution.vue";

export default {
  name: 'special-gifts-solutions',
  components: {SpecialGiftsSolution},
  data() {
    return {
      currentSolution: {
        trigger: null,
      },
    }
  },
  computed: {
    items() {
      const data = this.$store.state.page?.SpecialGiftsController?.specialGift;
      const solutions = [];

      if (!data) return [];

      data.forEach(el => {
        solutions.push({
          id: el.ID,
          name: el.NAME,
          menuName: el.PREVIEW_TEXT,
          anchor: el.CODE,
          images: el.PHOTOS,
        });
      });

      return solutions;
    }
  },
  methods: {
    onMenuItemClick(anchor) {
      if (!anchor) return;
      scrollTo(anchor, '-30%');
    }
  },
  mounted() {
    this.currentSolution.trigger = this.items[0].anchor;
  }
}
</script>

<style lang="scss">
.special-gifts-solutions {
  h2 {
    margin-bottom: 36px;

    @include up($md) {
      margin-bottom: 30px;
    }
  }

  &__menu {
    position: sticky;
    top: 112px;
    z-index: 2;
    background: $white-alpha;

    @include up($lg) {
      top: 123px;
    }
  }

  &__menu-item {
    transition: 0.2s ease-in-out !important;

    &.--active, &:hover {
      color: $golden !important;
    }
  }

  &__items {
    gap: 12px;
    margin-top: 37px;

    @include up($md) {
      gap: 144px;
      margin-top: 70px;
    }
  }
}
</style>